function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEFAULT_WATERMARK_DATA = {
  position: 9,
  size: 40,
  opacity: 40,
  imageUrl: '8bb438_9ad16b69fd1b4ab29324f97f1323b05a~mv2.png',
  imageRatio: 1.42517815
};

var WatermarkHelper = /*#__PURE__*/function () {
  function WatermarkHelper() {
    this.watermark = DEFAULT_WATERMARK_DATA;
    this.watermarkWasSet = false;
    this.init();
  }

  var _proto = WatermarkHelper.prototype;

  _proto.init = function init() {
    var _this = this;

    try {
      if (!this.watermarkWasSet && this.isStoreIframe) {
        import(
        /* webpackChunkName: "watermarkApi" */
        './watermarkApi').then(function (module) {
          var watermarkApi = module["default"];
          watermarkApi.getWatermarkData().then(function (data) {
            if (!_this.watermarkWasSet) {
              _this.setWatermark(data);
            }
          });
        });
      }
    } catch (e) {
      console.error('Cannot get watermark', e); //eslint-disable-line
    }
  };

  _proto.isValid = function isValid(watermark) {
    return !!watermark && typeof watermark.position !== 'undefined' && typeof watermark.size !== 'undefined' && typeof watermark.opacity !== 'undefined' && typeof watermark.imageUrl !== 'undefined' && typeof watermark.imageRatio !== 'undefined';
  };

  _proto.setWatermark = function setWatermark(watermark) {
    if (this.isValid(watermark)) {
      this.watermark = watermark;
      this.watermarkWasSet = true;
    }
  };

  _createClass(WatermarkHelper, [{
    key: "isStoreIframe",
    get: function get() {
      // allow watermark in art-store only
      if (typeof this.isStore === 'undefined') {
        try {
          this.isStore = window.location.search.toLowerCase().indexOf('isstore') > -1;
        } catch (e) {
          this.isStore = undefined;
          return false;
        }
      }

      return this.isStore;
    }
  }, {
    key: "exists",
    get: function get() {
      return this.watermarkWasSet && Object.keys(this.watermark).length > 0;
    }
  }, {
    key: "obj",
    get: function get() {
      return this.watermark;
    }
  }, {
    key: "str",
    get: function get() {
      return this.exists ? this.watermark.imageUrl + "-" + this.watermark.opacity + "-" + this.watermark.position + "-" + this.watermark.size : '';
    }
  }, {
    key: "strUrl",
    get: function get() {
      return this.exists ? ",wm_" + this.str : '';
    }
  }]);

  return WatermarkHelper;
}();

export default new WatermarkHelper();